import { AUTH } from "constants/types";

const initState = {
  loading: true,
  isAuth: false,
  profile: null,
  shop: null,
  notifications: [],
  shops: [],
  status: null,
  settings: null,
  customer: {}
}

const AuthReducer = (state = initState, action) => {
  const { type, payload } = action
  
  switch(type){

    case AUTH.SIGNED_IN:
      return {
        ...state,
        loading: false,
        isAuth: true,
        shop: payload ? Object.assign({}, payload.shop) : state.shop,
        profile: payload ? Object.assign({}, {
          ...payload.user,
          // subscription: false
        }) : state.profile,
        status: payload ? (payload.shop || {}).notices_banner : state.status,
      }

    case AUTH.SIGNED_OUT:
      return {
        ...state,
        isAuth: false
      }

    case AUTH.CUSTOMER_INFO:
      return {
        ...state,
        customer: payload
      }

    case AUTH.USER_SETTINGS:
      return {
        ...state,
        settings: Object.assign({}, payload)
      }

    case AUTH.MARK_AS_READ:
      return {
        ...state,
        notifications: []
      }

    case AUTH.USER_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload.data
      }

    case AUTH.USER_SHOPS:
      return {
        ...state,
        shops: payload.data.shops
      }

    default:
        return state
  }
}

export default AuthReducer